// Shared email HTML boundary. Keep editor and preview sanitization consistent.
export const mailerFontsUrl = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;600&family=Newsreader:opsz,wght@6..72,600;6..72,700&display=swap';
export const mailerPreviewCss = 'body{margin:0;background:#F3F4F6}.mailer-button:hover{background:#1D4ED8}';
export const mailerPreviewHead = '<meta charset="utf-8"><link rel="stylesheet" href="' + mailerFontsUrl + '"><style>' + mailerPreviewCss + '</style>';
export const unsafeTags = new Set(['script', 'iframe', 'object', 'embed', 'form', 'svg', 'math', 'base', 'meta', 'link', 'video', 'audio']);
export const unsafeAttribute = (name, value) => {
  const key = name.toLowerCase();
  if (!/^[a-z_:][a-z0-9_.:-]*$/.test(key)) return true;
  if (key.startsWith('on') || ['srcdoc', '__proto__', 'constructor', 'prototype'].includes(key)) return true;
  if (value !== null && typeof value === 'object') return true;
  const url = String(value || '').replace(/[\s\x00-\x1f\x7f]/g, '');
  return ['href', 'src', 'action', 'formaction', 'background', 'poster', 'xlink:href', 'srcset'].includes(key) && /^[^/#?]*:/.test(url) && !/^(https?|mailto|tel|cid):/i.test(url);
};
export const catalogImages = new Set(['care-phone.png', 'care-checkup.png', 'care-wellbeing.png', 'ahc-preventive-art.png', 'prelaunch-special-art.png', 'prelaunch-surprise-art.png'].map(name => '/mailer-assets/' + name).concat(['opd', 'ahc', 'ahc-split', 'combined', 'ahc-preventive', 'care-phone', 'care-checkup', 'care-wellbeing', 'prelaunch-special', 'prelaunch-surprise'].map(name => '/mailer-assets/ds/ds-' + name + '.png')));
const loopback = host => host === 'localhost' || host.endsWith('.localhost') || /^127\./.test(host) || ['[::1]', '0.0.0.0'].includes(host);
export const publicCatalogImage = source => {
  let url;
  try { url = new URL(source, window.location.origin); } catch { return source; }
  const frontend = url.origin === window.location.origin || ['datavue.ekincare.com', 'corporatestaging.ekincare.com'].includes(url.hostname);
  if (!catalogImages.has(url.pathname) || (/^(?:[a-z][a-z\d+.-]*:)?\/\//i.test(source) && !loopback(url.hostname) && !frontend)) return source;
  let backend;
  try { backend = new URL(window.API_URL); } catch { /* Checked below before using a catalog image. */ }
  if (!backend || !['https:', 'http:'].includes(backend.protocol) || loopback(backend.hostname)) {
    throw new Error('Template artwork needs a public backend URL before this email can be saved.');
  }
  return new URL(url.pathname, backend.origin).href;
};
export const publicCatalogHTML = html => {
  if (!html.includes('/mailer-assets/')) return html;
  const fragment = document.createElement('template'); fragment.innerHTML = html;
  fragment.content.querySelectorAll('img[src]').forEach(img => img.setAttribute('src', publicCatalogImage(img.getAttribute('src'))));
  return fragment.innerHTML;
};

export const cleanMailerHTML = html => {
  const fragment = document.createElement('template');
  fragment.innerHTML = html;
  fragment.content.querySelectorAll('*').forEach(element => {
    if (unsafeTags.has(element.tagName.toLowerCase())) element.remove();
    else [...element.attributes].forEach(attribute => { if (unsafeAttribute(attribute.name, attribute.value)) element.removeAttribute(attribute.name); });
  });
  // Old Grapes projects lost THEAD wrappers when saved. Mark their header row
  // directly so the existing mobile rule still hides it after HTML repair.
  const matrices = new Set([...fragment.content.querySelectorAll('.wd-escalation-cell')].map(cell => cell.closest('table')).filter(Boolean));
  matrices.forEach(table => [...table.rows].filter(row => row.closest('table') === table && row.cells.length && [...row.cells].every(cell => cell.tagName === 'TH'))
    .forEach(row => row.classList.add('wd-escalation-head')));
  return publicCatalogHTML(fragment.innerHTML);
};
